import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'vault-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SidebarComponent {}
